import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function ChatMessage(props) {
  const userSelector = useSelector((state) => state.user);

  const [expanded, setExpanded] = useState(false);

  return (
    <button
      onClick={() => setExpanded(expanded)}
      className={
        "flex mx-2 " +
        (props.data.sender === userSelector.user._id
          ? "justify-end"
          : props.data.sender === "system"
          ? "justify-center"
          : "justify-start")
      }
    >
      <label
        className={
          "p-2 break-all text-black max-w-xs md:max-w-2xl  " +
          (props.data.sender === userSelector.user._id
            ? "bg-gray-100 rounded-l-lg rounded-tr-lg"
            : props.data.sender === "system"
            ? "font-bold"
            : "bg-blue-100 rounded-r-lg rounded-tl-lg")
        }
      >
        {props.data.body}
      </label>
    </button>
  );
}
